import React, {Component, Suspense} from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Badge, Tooltip, Menu, Dropdown } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as ComparisonIcon}  from "../utils/ComparisonIcon.svg";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import '../styles/NavBar.scss';
import { ReactComponent as MapleLeafIcon } from "../utils/MapleLeafIcon.svg";
import { Event } from '../utils/tracking.js';
import { DownOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { createBrowserHistory } from 'history';

const Search = React.lazy(() => import('./Search.jsx'));
const ProductsDropdown = React.lazy(() => import('./ProductsDropdown.jsx'));
const history = createBrowserHistory();

export default class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openKeys: [], // Track open submenus
            collapsedIsShow: false,
            toggleIsWork: true,
            listOfFilteredSuggestions: null
        }
    }

    componentDidMount() {
        const hash = window.location.hash || '#';
        if (hash === "#line-card") {
            history.push(`/resources#line-card`)
        } else if (hash === "#product-compatibility") {
            history.push(`/resources#product-compatibility`)
        } else if (hash === '#product-certification-listing') {
            history.push(`/resources/product-certification-listing`)
        } else if (hash === '#catalogue') {
            history.push(`/resources#catalogue`)
        }
    }

    Logout = () => {
        Cookies.remove('user_id');
        Cookies.remove('userType');
        Cookies.remove('userId');
        Cookies.remove('accountType');
        Cookies.remove('department');
        Cookies.remove('company_name');
        Cookies.remove('userSwitch');
        window.location.href="/login";
    }

    PartnersLogout = () => {
        Cookies.remove('user_id');
        Cookies.remove('userType');
        Cookies.remove('userId');
        Cookies.remove('accountType');
        Cookies.remove('department');
        Cookies.remove('company_name');
        window.location.href = '/products-led';
    }

    renderMenu() {
        return (
        <Menu 
            style={{top: "-11px"}}
            mode="inline" // Make the menu inline, which is more suited for opening on click
            triggerSubMenuAction="click" // Ensure submenus open on click, not hover    
            openKeys={this.state.openKeys} // Controlled open keys
            onOpenChange={(openKeys) => this.setState({ openKeys })} // Update on submenu open/close
        >
            <Menu.Item>
                <Nav.Link 
                as={Link} 
                to="/resources/specsheets-led" 
                href="/resources/specsheets-led" 
                onClick={()=> {
                    Event("Nav bar", `NavBarSS clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar spec sheets");
                    this.setState({ openKeys: [] }); // Close submenu when clicked
                }}
                >          
                <span>Specification, Installation & Photometrics (IES) Library</span>   
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                as={Link} 
                to="/resources#line-card" 
                href="/resources#line-card" 
                onClick={()=> {
                    Event("Nav bar", `NavBarProductLineCard clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Product Line Card");
                    this.setState({ openKeys: [] }); // Close submenu when clicked
                }}
                >          
                <span>Product Line Card</span>   
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                as={Link}  
                to="/resources#catalogue" 
                href="/resources#catalogue" 
                onClick={()=> {
                    Event("Nav bar", `NavBarProductcatalogue clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar product catalogue");
                    this.setState({ openKeys: [] }); // Close submenu when clicked
                }}
                >
                <span>Product Catalogue</span>
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                    as={Link} 
                    smooth 
                    to="/resources/product-certification-listing" 
                    href="/resources/product-certification-listing" 
                    onClick={()=> {
                        Event("Nav bar", `NavBarCertif clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Product Certification Listing");
                        this.setState({ openKeys: [] }); // Close submenu when clicked
                    }}
                >
                    <span>Product Certification Listing</span>
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                    as={Link} 
                    smooth 
                    to="/resources#product-compatibility" 
                    href="/resources#product-compatibility" 
                    onClick={()=> {
                        Event("Nav bar", `NavBarProductCompat clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Product Compatibility");
                        this.setState({ openKeys: [] }); // Close submenu when clicked
                    }}
                >
                    <span>Product Compatibility</span>
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                    as={Link} 
                    to="/lp/soe-listing" 
                    href="/lp/soe-listing" 
                    onClick={()=> {
                        Event("Nav bar", `NavBarSOE clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Retrofit Incentives");
                        this.setState({ openKeys: [] }); // Close submenu when clicked
                    }}
                >         
                    <span>Retrofit Incentives</span>         
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                    as={Link} 
                    to="/support" 
                    href="/support" 
                    onClick={()=> {
                        Event("Nav bar", `NavBarPolicies clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Policies & Product Support");
                        this.setState({ openKeys: [] }); // Close submenu when clicked
                    }}
                >         
                    <span>Policies & Product Support</span>         
                </Nav.Link>
            </Menu.Item>
            <Menu.Item>
                <Nav.Link 
                    as={Link} 
                    to="/returns" 
                    href="/returns" 
                    onClick={()=> {
                        Event("Nav bar", `NavBarReturns clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Returns");
                        this.setState({ openKeys: [] }); // Close submenu when clicked
                    }}
                >         
                    <span>Returns</span>         
                </Nav.Link>
            </Menu.Item>
        </Menu>
        )
    }

    render() {
        const profileUrl = "/portal";
        const partnerProfileUrl = '/partners/portal';
        const isLoggedIn = !!Cookies.get('user_id')
        const isPartnerLoggedIn = !!Cookies.get('partner_id')
        const menu = this.renderMenu();
        return ( 
            <div className="nav-bar-container local-bootstrap">
                {isLoggedIn &&
                    <Navbar collapseOnSelect={true} expand="xl" variant="light">
                        <Navbar.Brand>
                            <div className="nav-bar-logo">
                                <Nav.Link 
                                    as={Link} 
                                    to="/" 
                                    href="/" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarLogo clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar logo");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='img-container'>
                                        <img
                                            width="157"
                                            height="55" 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/company-logo/EELighting_Logo.webp" 
                                            alt="eel logo"                                            
                                        />
                                    </div>
                                </Nav.Link>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav>
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <ProductsDropdown />
                                </Suspense>
                                <Dropdown 
                                    overlay={menu}
                                    trigger={['click']}
                                >
                                    <Nav.Link 
                                        to='/resources' 
                                        href='/resources' 
                                        as={Link} 
                                        className="nav-bar" 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarResources clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar resources");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >                              
                                        <span>Resources<DownOutlined id="down" /></span>                            
                                    </Nav.Link>
                                </Dropdown>   
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/where-to-buy" 
                                    href="/where-to-buy" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarWhere to buy clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar where to buy");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Where to Buy
                                </Nav.Link>    
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/quoteme-listing" 
                                    href="/lp/quoteme-listing" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarQuote Me clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Quote Me");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Quote Me
                                </Nav.Link>                 
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/contact" 
                                    href="/contact" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarContact clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar contact us");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Contact Us
                                </Nav.Link>
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/order-tracking" 
                                    href="/lp/order-tracking" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarOrderTrack clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar order tracking");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='nav-dot-container'>              
                                        <div>Order Tracking</div>
                                        <div className='dot-container'>
                                        <img 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/generic-assets/green-navigation-dot.png"
                                            alt="green navigation dot"
                                            />                                
                                        </div>    
                                    </div>
                                </Nav.Link>
                                <Tooltip className="nav-icon" title="Comparison">
                                    <Nav.Link 
                                        aria-label="Product comparison link" 
                                        as={Link} 
                                        to={this.props.comparisonUrl} 
                                        href={this.props.comparisonUrl} 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarComparison clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar comparison");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >
                                        <Badge 
                                            title=" " 
                                            overflowCount={10} 
                                            count={this.props.productCompareCount}
                                        >
                                            <Icon component={ComparisonIcon} />
                                        </Badge>
                                    </Nav.Link>
                                </Tooltip>
                                <Nav.Link 
                                    as={Link} 
                                    to={profileUrl}
                                    href={profileUrl}
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarProfile clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar profile");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Profile
                                </Nav.Link>
                                <Nav.Link 
                                    onClick={() => {
                                        this.Logout(); 
                                        Event("Nav bar", `NavBarLogout clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar logout");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Logout
                                </Nav.Link>
                                <div id="proudly-canadian-container-flex">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>                            
                            </Nav>
                        </Navbar.Collapse>
                            <div id="search-container">
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <Search 
                                        handleSearch={this.props.handleSearch}
                                        className="search" 
                                        onSelect={this.props.onSelectFromSearch} 
                                        onClick={()=> Event("Nav bar", `NavBarSearch clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar search")}
                                    />
                                </Suspense>
                                <div id="proudly-canadian-container">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>      
                            </div>
                    </Navbar>  
                }
                {isPartnerLoggedIn &&
                    <Navbar collapseOnSelect={true} expand="xl" variant="light">
                        <Navbar.Brand>
                            <div className="nav-bar-logo">
                                <Nav.Link 
                                    as={Link} 
                                    to="/" 
                                    href="/" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarLogo clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar logo");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='img-container'>
                                        <img 
                                            width="157"
                                            height="55" 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/company-logo/EELighting_Logo.webp" 
                                            alt="eel logo"                                            
                                        />
                                    </div>
                                </Nav.Link>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav>
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <ProductsDropdown />
                                </Suspense>
                                <Dropdown 
                                    overlay={menu}
                                    trigger={['click']}
                                >
                                    <Nav.Link 
                                        to='/resources' 
                                        href='/resources' 
                                        as={Link} 
                                        className="nav-bar" 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarResources clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar resources");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >                              
                                        <span>Resources<DownOutlined id="down" /></span>                            
                                    </Nav.Link>
                                </Dropdown>   
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/where-to-buy" 
                                    href="/where-to-buy" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarWhere to buy clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar where to buy");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Where to Buy
                                </Nav.Link>    
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/quoteme-listing" 
                                    href="/lp/quoteme-listing" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarQuote Me clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Quote Me");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Quote Me
                                </Nav.Link>                 
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/contact" 
                                    href="/contact" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarContact clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar contact us");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Contact Us
                                </Nav.Link>
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/order-tracking" 
                                    href="/lp/order-tracking" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarOrderTrack clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar order tracking");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='nav-dot-container'>              
                                        <div>Order Tracking</div>
                                        <div className='dot-container'>
                                        <img 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/generic-assets/green-navigation-dot.png"
                                            alt="green navigation dot"
                                            />                                
                                        </div>    
                                    </div>
                                </Nav.Link>
                                <Tooltip className="nav-icon" title="Comparison">
                                    <Nav.Link 
                                        aria-label="Product comparison link" 
                                        as={Link} 
                                        to={this.props.comparisonUrl} 
                                        href={this.props.comparisonUrl} 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarComparison clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar comparison");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >
                                        <Badge 
                                            title=" " 
                                            overflowCount={10} 
                                            count={this.props.productCompareCount}
                                        >
                                            <Icon component={ComparisonIcon} />
                                        </Badge>
                                    </Nav.Link>
                                </Tooltip>
                                <Nav.Link 
                                    as={Link} 
                                    to={partnerProfileUrl}
                                    href={partnerProfileUrl}
                                    onClick={()=> Event("Nav bar", `NavBarPartner Profile clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Partner profile")}
                                >
                                    Partner Portal
                                </Nav.Link>
                                <Nav.Link 
                                    onClick={() => {
                                        this.PartnersLogout(); 
                                        Event("Nav bar", `NavBarPartner Logout clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Partner logout");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Logout
                                </Nav.Link>
                                <div id="proudly-canadian-container-flex">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>                            
                            </Nav>
                        </Navbar.Collapse>
                            <div id="search-container">
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <Search 
                                        handleSearch={this.props.handleSearch}
                                        className="search" 
                                        onSelect={this.props.onSelectFromSearch} 
                                        onClick={()=> Event("Nav bar", `NavBarSearch clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar search")}
                                    />
                                </Suspense>
                                <div id="proudly-canadian-container">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>      
                            </div>
                    </Navbar>  
                }
                {!isLoggedIn && !isPartnerLoggedIn &&
                    <Navbar collapseOnSelect={true} expand="xl" variant="light">
                        <Navbar.Brand>
                            <div className="nav-bar-logo">
                                <Nav.Link 
                                    as={Link} 
                                    to="/" 
                                    href="/" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarLogo clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar logo");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='img-container'>
                                        <img 
                                            width="157"
                                            height="55" 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/company-logo/EELighting_Logo.webp" 
                                            alt="eel logo"                                            
                                        />
                                    </div>
                                </Nav.Link>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav>
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <ProductsDropdown />
                                </Suspense>
                                {/* <Nav.Link className="nav-bar" as={Link} to="/where-to-buy" href="/where-to-buy" onClick={()=> Event("Nav bar", `Where to buy link from Nav bar clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar where to buy")}>Where to Buy</Nav.Link>  */}
                                
                                <Dropdown 
                                    overlay={menu}
                                    trigger={['click']}
                                >
                                    <Nav.Link 
                                        to='/resources' 
                                        href='/resources' 
                                        as={Link} 
                                        className="nav-bar" 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarResources clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar resources");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >                              
                                        <span>Resources<DownOutlined id="down" /></span>                            
                                    </Nav.Link>
                                </Dropdown>
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/where-to-buy" 
                                    href="/where-to-buy" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarWhere to buy clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar where to buy");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Where to Buy
                                </Nav.Link>  
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/quoteme-listing" 
                                    href="/lp/quoteme-listing" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarQuote Me clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Quote Me");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Quote Me
                                </Nav.Link>                     
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/contact" 
                                    href="/contact" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarContact clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar contact us");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Contact Us
                                </Nav.Link>  
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/lp/order-tracking" 
                                    href="/lp/order-tracking" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarOrderTrack clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar order tracking");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    <div className='nav-dot-container'>              
                                        <div>Order Tracking</div>
                                        <div className='dot-container'>
                                        <img 
                                            src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/generic-assets/green-navigation-dot.png"
                                            alt="green navigation dot"
                                            />                                
                                        </div>    
                                    </div>
                                </Nav.Link>                              
                                <Tooltip className="nav-icon" title="Comparison">
                                    <Nav.Link 
                                        aria-label="Product comparison link" 
                                        as={Link} 
                                        to={this.props.comparisonUrl} 
                                        href={this.props.comparisonUrl} 
                                        onClick={()=> {
                                            Event("Nav bar", `NavBarComparison clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar comparison");
                                            this.setState({ openKeys: [] }); // Close submenu when clicked
                                        }}
                                    >
                                        <Badge 
                                            title=" " 
                                            overflowCount={10} 
                                            count={this.props.productCompareCount}
                                        >
                                            <Icon component={ComparisonIcon} />
                                        </Badge>
                                    </Nav.Link>
                                </Tooltip>   
                                <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/login" 
                                    href="/login" 
                                    onClick={()=> {
                                        Event("Nav bar", `NavBarLogin clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Login");
                                        this.setState({ openKeys: [] }); // Close submenu when clicked
                                    }}
                                >
                                    Login
                                </Nav.Link>
                                {/* <Nav.Link 
                                    className="nav-bar" 
                                    as={Link} 
                                    to="/partners/login" 
                                    href="/partners/login" 
                                    onClick={()=> Event("Nav bar", `Partners Login link from Nav bar clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar Partners Login")}
                                >
                                    Partner Portal
                                </Nav.Link>                              */}
                                <div id="proudly-canadian-container-flex">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>                            
                            </Nav>
                        </Navbar.Collapse>
                            <div id="search-container">
                                <Suspense fallback={<div><Icon type="loading" /> Loading...</div>}>
                                    <Search 
                                        handleSearch={this.props.handleSearch}
                                        className="search" 
                                        onSelect={this.props.onSelectFromSearch} 
                                        onClick={()=> Event("Nav bar", `NavBarSearch clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Nav bar search")}
                                    />
                                </Suspense>
                                <div id="proudly-canadian-container">                    
                                    <p>Proudly Canadian</p>
                                    <Icon component={MapleLeafIcon} />
                                </div>      
                            </div>
                    </Navbar>                  
                }       
            </div>
        );
    }
}